import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
  Container,
  Form,
  Row,
  Col,
  Button,
  Card
} from 'react-bootstrap';
import TesterBudNavbar from '../../subComponent/TesterBudNavBar';
import HeroImage from '../icons/form-icon.png';

const AutomatingWebForms = () => {
  const [country, setCountry] = useState('');
  const [title, setTitle] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState(null);
  const [doj, setDoj] = useState('');
  const [email, setEmail] = useState('');
  const [phoneCode, setPhoneCode] = useState('+1');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [communicationPreference, setCommunicationPreference] = useState('');
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const countries = ['United States', 'Canada', 'United Kingdom', 'India', 'Australia', 'Other'];
  const titles = ['', 'Mr.', 'Ms.', 'Mrs.', 'Dr.', 'Prof.'];
  const countryCodes = ['+1', '+44', '+91', '+61', '+86', '+Other'];

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateDOJ = (date) => /^\d{2}\/\d{2}\/\d{4}$/.test(date);

  const validateForm = () => {
    const newErrors = {};
    if (!country) newErrors.country = 'Country of Residence is required';
    if (!title) newErrors.title = 'Title is required';
    if (!firstName) newErrors.firstName = 'First Name is required';
    if (!lastName) newErrors.lastName = 'Last Name is required';
    if (!dob) newErrors.dob = 'Date of Birth is required';
    if (!doj) newErrors.doj = 'Date of Joining is required (dd/mm/yyyy)';
    else if (!validateDOJ(doj)) newErrors.doj = 'Date of Joining format should be dd/mm/yyyy';
    if (!email) newErrors.email = 'Email Address is required';
    else if (!validateEmail(email)) newErrors.email = 'Invalid Email Address';
    if (!phoneNumber) newErrors.phoneNumber = 'Phone Number is required';
    if (!communicationPreference) newErrors.communicationPreference = 'Please select a Communication Preference';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setSuccess(true);
      setCountry('');
      setTitle('');
      setFirstName('');
      setLastName('');
      setDob(null);
      setDoj('');
      setEmail('');
      setPhoneCode('+1');
      setPhoneNumber('');
      setCommunicationPreference('');
      setErrors({});
    }
  };

  const handleClear = () => {
    setCountry('');
    setTitle('');
    setFirstName('');
    setLastName('');
    setDob(null);
    setDoj('');
    setEmail('');
    setPhoneCode('+1');
    setPhoneNumber('');
    setCommunicationPreference('');
    setErrors({});
    setSuccess(false);
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>Practice and Learn Selenium Web Form Automation | TesterBud</title>
      </Helmet>
      <Container fluid className="hero-section bg-primary text-white py-4" style={{ position: 'relative', overflow: 'hidden' }}>
        <Row className="align-items-center justify-content-center">

          <Col md={6} className="text-center text-md-start">
            <h1 className="display-4 fw-bold mb-3">TesterBud: Dummy E-commerce Application </h1>

            <p className="lead mb-4">
              Practice automating shopping cart functionalities, order placement, and product browsing on a realistic demo e-commerce site. 🚀
            </p>


          </Col>
          <Col md={5} className="d-none d-md-block text-center">
            {/* Replace with your actual hero image component or import */}
            <div style={{ width: '50%', height: '50%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
              <div
                style={{
                  width: '50%', // Adjust the size of the circular area
                  height: '50%', // Ensure width and height are equal for a perfect circle
                  borderRadius: '70%', // This creates the circular shape
                  overflow: 'auto', // Clips the image to the circle
                  marginTop: '-4%',
                  marginRight: '10%',
                  marginBottom: '-4%',
                }}
              >
                <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain', // Or 'cover' depending on desired behavior
                }} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <TesterBudNavbar/>
      <Container className="py-5">
        <Card className="shadow-lg p-4">
          <Card.Body>
            <h2 className="text-center mb-4">Automate Web Forms</h2>
            <p className="text-center text-muted mb-4">
              <b>We do not store any data. Use dummy data only for automation practice.</b>
            </p>
            {success ? (
  <Card className="text-center border-success p-4">
    <div className="d-flex justify-content-end">
      <Button variant="outline-danger" size="sm" onClick={() => setSuccess(false)}>
        ✕
      </Button>
    </div>
    <Card.Body>
      <Card.Title className="text-success">Details Successfully Added!</Card.Title>
      <Card.Text>Thank you for practicing form automation.</Card.Text>
      <Card.Text className="text-muted small">
        We do not store any data. Please avoid entering personal information.
        Use only dummy data for practicing automation scripts. 😊
      </Card.Text>
      <Button variant="primary" className="mt-3" onClick={() => setSuccess(false)}>
        Go Back to Form
      </Button>
    </Card.Body>
  </Card>
) : (
  <Form onSubmit={handleSubmit}>

                <Form.Group className="mb-3">
                  <Form.Label>Country of Residence</Form.Label>
                  <Form.Select value={country} onChange={(e) => setCountry(e.target.value)}>
                    <option value="">Select Country</option>
                    {countries.map((c) => <option key={c} value={c}>{c}</option>)}
                  </Form.Select>
                  {errors.country && <Form.Text className="text-danger">{errors.country}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Select value={title} onChange={(e) => setTitle(e.target.value)}>
                    {titles.map((t) => <option key={t} value={t}>{t || 'Select Title'}</option>)}
                  </Form.Select>
                  {errors.title && <Form.Text className="text-danger">{errors.title}</Form.Text>}
                </Form.Group>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    {errors.firstName && <Form.Text className="text-danger">{errors.firstName}</Form.Text>}
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    {errors.lastName && <Form.Text className="text-danger">{errors.lastName}</Form.Text>}
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>Date of Birth</Form.Label>
                  <DatePicker
                    selected={dob}
                    onChange={(date) => setDob(date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="YYYY-MM-DD"
                  />
                  {errors.dob && <Form.Text className="text-danger">{errors.dob}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Date of Joining (dd/mm/yyyy)</Form.Label>
                  <Form.Control
                    type="text"
                    value={doj}
                    onChange={(e) => setDoj(e.target.value)}
                    placeholder="dd/mm/yyyy"
                  />
                  {errors.doj && <Form.Text className="text-danger">{errors.doj}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <Form.Text className="text-danger">{errors.email}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Row>
                    <Col md={4}>
                      <Form.Select value={phoneCode} onChange={(e) => setPhoneCode(e.target.value)}>
                        {countryCodes.map((code) => <option key={code} value={code}>{code}</option>)}
                      </Form.Select>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                    </Col>
                  </Row>
                  {errors.phoneNumber && <Form.Text className="text-danger">{errors.phoneNumber}</Form.Text>}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Preferred Communication Method</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Email"
                      type="radio"
                      value="email"
                      checked={communicationPreference === 'email'}
                      onChange={(e) => setCommunicationPreference(e.target.value)}
                    />
                    <Form.Check
                      inline
                      label="Phone"
                      type="radio"
                      value="phone"
                      checked={communicationPreference === 'phone'}
                      onChange={(e) => setCommunicationPreference(e.target.value)}
                    />
                  </div>
                  {errors.communicationPreference && (
                    <Form.Text className="text-danger">{errors.communicationPreference}</Form.Text>
                  )}
                </Form.Group>

                <div className="d-flex justify-content-end gap-2">
                  <Button variant="secondary" onClick={handleClear}>Clear</Button>
                  <Button type="submit" variant="primary">Submit</Button>
                </div>
              </Form>
            )}
          </Card.Body>
        </Card>
      </Container>
      <footer className="bg-dark text-light text-center py-4 mt-auto">
              <Container>
                <p className="mb-1">Ready to start automating? Explore, practice, and master!</p>
                <small>© 2025 TesterBud | Built for learners by learners 🚀</small>
              </Container>
            </footer>
    </HelmetProvider>
  );
};

export default AutomatingWebForms;
